import { render } from "./TableRow.vue?vue&type=template&id=26484d3e&scoped=true"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"

import "./TableRow.vue?vue&type=style&index=0&id=26484d3e&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26484d3e"]])

export default __exports__